// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActivatorsController from "./activators_controller"
application.register("activators", ActivatorsController)

import AccordionDeepLinkController from "./accordion_deep_link_controller"
application.register("accordion-deep-link", AccordionDeepLinkController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BatchIosController from "./batch_ios_controller"
application.register("batch-ios", BatchIosController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ClubOptionsController from "./club_options_controller"
application.register("club-options", ClubOptionsController)

import ExportBonusController from "./export_bonus_controller"
application.register("export-bonus", ExportBonusController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import FlatpickrDateController from "./flatpickr_date_controller"
application.register("flatpickr-date", FlatpickrDateController)

import FlatpickrTimeController from "./flatpickr_time_controller"
application.register("flatpickr-time", FlatpickrTimeController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import OperationsController from "./operations_controller"
application.register("operations", OperationsController)

import OrdersController from "./orders_controller"
application.register("orders", OrdersController)

import QsoFormLoadedController from "./qso_form_loaded_controller"
application.register("qso-form-loaded", QsoFormLoadedController)

import QsosController from "./qsos_controller"
application.register("qsos", QsosController)
